module.exports = __webpack_public_path__ + "static/media/facebook.8714ef40.svg";